<!--  -->
<template>
  <div>
    <van-overlay :show="showShare" @click="showShare = false">
      <transition name="van-slide-up">
      <div class="share-pop-view" @click.stop>
        <div class="share-pop-desc-view">
          <div class="share-desc-icon">
            <van-image width="40px" height="40px" radius="5" :src="canvasImg"/>
          </div>
          <div class="share-desc-info-view">
            <div class="share-desc-title">{{title}}</div>
            <!-- <div class="share-desc-sub-text">海报描述海报描述海报描述</div> -->
          </div>
        </div>
        <div class="share-pop-btns-view">
          <div class="share-btns-view van-hairline--bottom">
            <div class="share-btn" @click="share('wx')">
              <van-image width="40px" height="40px" :src="require('@/assets/wx.png')"/>
              <div class="share-btn-title">微信</div>
            </div>
            <div class="share-btn" @click="share('moments')">
              <van-image width="40px" height="40px" :src="require('@/assets/moments.png')"/>
              <div class="share-btn-title">朋友圈</div>
            </div>
            <div class="share-btn" 
            v-clipboard:copy="shareUrl" 
            v-clipboard:success="copy" 
            v-clipboard:error="onError">
              <van-image width="40px" height="40px" :src="require('@/assets/copyUrl.png')"/>
              <div class="share-btn-title">复制链接</div>
            </div>
          </div>
          <div class="cancel-btn" @click="showShare = false">取 消</div>
        </div>
      </div>
      </transition>
    </van-overlay>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    canvasImg: {
      type: String,
      defualt: ''
    },
    title: {
      type: String,
      defualt: ''
    },
    posterId: {
      type: Number,
      default: 0
    }
  },
  data () {
    // 这里存放数据
    return {
      showShare: false,
      shareUrl: '',
      shareImg: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /**
     * 分享
     */
    share(type) {
      if (type == 'wx') {
        var routerId = JSON.stringify({type: 'wx', url: this.shareUrl, title: this.title, desc: '', shareImg: this.canvasImg});
        var params = {
          path: 'share_poster',
          routerId: routerId
        }
        this.hrefAppFn(params);
      }
      if (type == 'moments') {
        var routerId = JSON.stringify({type: 'moments', url: this.shareUrl, title: this.title, desc: '', shareImg: this.canvasImg});
        var params = {
          path: 'share_poster',
          routerId: routerId
        }
        this.showShare = false;
        this.hrefAppFn(params);
      }
    },
    copy() {
      this.$Toast.success('复制成功');
      this.showShare = false;
    },
    onError() {
      this.$Toast.success('复制失败');
      this.showShare = false;
    },
    setShow(status, id) {
      this.showShare = status;
      var afUrl = window.location.href.split('/#/')[0]
      var url = afUrl + '/#/poster/show?id=' + id;
      this.shareUrl = url;
    },
    hrefAppFn(params) {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isAndroid) {
        window.messageHandlers.hrefApp(JSON.stringify(params))
      } else {
        window.webkit.messageHandlers.hrefApp.postMessage(JSON.stringify(params))
      }
    }, 
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.share-pop-view {
  padding: 20px 15px;
}
.share-pop-btns-view {
  position: fixed;
  bottom: 20px;
  width: 90%;
  margin-left: -45%;
  left: 50%;
  height: 130.5px;
  background-color: #FFFFFF;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.share-pop-desc-view {
  position: fixed;
  height: 70px;
  background: #FFFFFF;
  border-radius: 5px;
  bottom: 154.5px;
  width: 90%;
  margin-left: -45%;
  left: 50%;
  background-color: #FFFFFF;
  display: flex;
}
.share-desc-icon {
  padding: 15px 0px 15px 15px;
}
.share-desc-info-view {
  padding: 15px;
  flex: 1;
}
.share-desc-title {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424242;
}
.share-desc-sub-text {
  margin-top: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.share-btns-view {
  display: flex;
  padding: 12px 0px;
}
.share-btn {
  flex: 1;
  text-align: center;
}
.share-btn-title {
  margin-top: 4px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424242;
}
.cancel-btn {
  background-color: #FFFFFF;
  text-align: center;
  line-height: 44px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #A9AFB8;
}
.tag-read {
  display: none;
}
</style>